<template>
  <p><slot></slot></p>
</template>

<script>
export default {
  name: "Paragraph"
};
</script>

<style lang="scss" scoped>
p {
  @include font-size(16px);
  line-height: 24px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  color: $dark-blue-3;
}
</style>
